import React from 'react';
import PropTypes from 'prop-types';
import Big from 'big.js';
import { formatAmount } from '@nbx/frontend-helpers/format';
import { isNullish } from 'helpers/objects';
import Text from 'components/shared/Text';
import styles from './styles.module.scss';

Big.RM = 0;

const renderSummary = item => {
  let display;
  if (isNullish(item.minDisplayValue) || isNullish(item.minTickLength)) return item.value;
  if (item.showLessThan && Big(item.value).gt(0) && Big(item.value).lt(item.minDisplayValue))
    display = `< ${item.minDisplayValue}`;
  else display = formatAmount(Big(item.value).toFixed(), item.minTickLength);
  display = `${display} ${item.symbol ?? ''}`;
  return display;
};

function OrderSummary(props) {
  return (
    <div className={styles.summaryWrap}>
      {props.error && <Text styles={[styles.summaryError]}>{props.error}</Text>}
      <div className={styles.summaryBody}>
        {props.summaryItems.map(item => {
          return (
            <div className={styles.summaryItem} key={item.title}>
              <Text muted styles={[styles.summaryItemTitle]}>
                {item.title}
              </Text>
              <div
                className={styles.summaryNumberContainer}
                style={{ color: item.muted ? 'var(--color-grey-dark)' : 'var(--text)' }}>
                <Text muted={item.muted} title={item.value} styles={[styles.summaryNumber]}>
                  {renderSummary(item)}
                </Text>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

OrderSummary.propTypes = {
  error: PropTypes.string,
  summaryItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      minDisplayValue: PropTypes.number,
      minTickLength: PropTypes.number,
      muted: PropTypes.bool,
      symbol: PropTypes.string
    })
  )
};

OrderSummary.defaultProps = {
  error: null,
  summaryItems: []
};

export default OrderSummary;
